
import common from './zh/common';
import home from './zh/home';
import airports from './zh/airports';
import profiles from './zh/profiles';
import settings from './zh/settings';
import reviews from './zh/reviews';
import inventory from './zh/inventory';
import auth from './zh/auth';
import navigation from './zh/navigation';

// Merge all translation categories into one object
const translations = {
  ...common,
  ...home,
  ...airports,
  ...profiles,
  ...settings,
  ...reviews,
  ...inventory,
  ...auth,
  ...navigation,
};

export default translations;
